import {
  FinanceComplianceSnapshotResourceTypeEnum,
  FinanceValueObjectsComplianceSnapshotEventEnum,
} from 'generated/resources/datatable.graphql'

import i18n from 'modules/core/lib/i18n'

export const mapComplianceSnapshotResourceType = (
  resourceType: FinanceComplianceSnapshotResourceTypeEnum
) => {
  switch (resourceType) {
    case 'quote':
      return i18n.t('finance.sale_invoices.detail.compliance_snapshots.resource_type.quote')
    case 'invoice':
      return i18n.t(
        'finance.sale_invoices.detail.compliance_snapshots.resource_type.financial_document'
      )
    default:
      return resourceType satisfies never
  }
}

export const mapComplianceSnapshotEventType = (
  eventType: FinanceValueObjectsComplianceSnapshotEventEnum
) => {
  switch (eventType) {
    case 'convert_quote_to_invoice':
      return i18n.t(
        'finance.sale_invoices.detail.compliance_snapshots.event_type.convert_quote_to_invoice'
      )
    case 'issued_document':
      return i18n.t('finance.sale_invoices.detail.compliance_snapshots.event_type.issued_document')
    case 'register_document':
      return i18n.t(
        'finance.sale_invoices.detail.compliance_snapshots.event_type.register_document'
      )
    case 'updated_document':
      return i18n.t('finance.sale_invoices.detail.compliance_snapshots.event_type.updated_document')
    case 'created_document':
      return i18n.t('finance.sale_invoices.detail.compliance_snapshots.event_type.created_document')
    default:
      return eventType satisfies never
  }
}
